import React from 'react';
import ProfileImage from '../../UI/ProfileImage/ProfileImage';
import Button from '../../UI/Button/Button'
import './AccExists.scss'
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { loginUrl, containerUrl } from '../../utils/constants';
import useDiffPan from '../../../assets/icons/useDiffPan.svg'
import gtmService from '../../Services/gtmService';
import mixpanelService from '../../Services/mixpanelService';
import mixpanelEvents, { getScreenName } from '../../../config/mixpanelEvents';

export interface AccExistsProps {
}

const AccExists: React.FC<AccExistsProps> = () => {

    // const history = useHistory();
    const navigate = useNavigate()

    return (
        <div className='accExts'>

            <div className='accExtsLogo'>
                <ProfileImage>
                    <img src={useDiffPan} alt="Use a different PAN" className='pfImg' />
                </ProfileImage>
            </div>

            <div className='accExtsHeading'>
                <span>Use a Different PAN</span>
            </div>

            <div className='accExtsInfo'>
                <p>An account already exists with this PAN.</p>
            </div>

            <div className='accExtsBtns'>
                <Button
                    btnName='Use Different PAN'
                    disabled={false}
                    isLoading={false}
                    onClick={() => {
                        gtmService({ action: 'USE_DIFF_PAN', label: 'DIFF_PAN' });
                        // history.push(containerUrl.pan)
                        navigate(containerUrl.pan)
                    }}
                />
            </div>

            <div className='accExtsLogin'>
                <span>Can’t access your account?</span>
                <button type='button' className='loginHelp'
                    onClick={() => {
                        try {
                            const screen_name = getScreenName(window.location.pathname);
                            if (screen_name) {
                                mixpanelService({
                                    event: mixpanelEvents.CTA_CLICKED,
                                    screen_name,
                                    text: "Login Help",
                                    cta_type: "sticky",
                                    cta_class: "secondary",
                                    cta_service: "AOJ",
                                });
                            }
                        } catch (e) {
                            console.error("mixpanel cta_clicked failed", e);
                        }
                        gtmService({ action: 'USE_DIFF_PAN', label: 'LOGIN_HELP' });
                        window.location.href = loginUrl
                    }} >Login Help</button>
            </div>
        </div >
    );
}

export default AccExists;